// extracted by mini-css-extract-plugin
export var actions = "_s0-4";
export var item = "_s0-1";
export var price = "_s0-3";
export var quantity = "_s0-2";
export var table = "_s0-0";